import React from 'react';
import { toast, ToastContainer } from 'react-toastify';

const UserRow = ({ alluserInfo,refetch,index }) => {
    const {email,role}=alluserInfo
    const makeAdmin=()=>{
        fetch(`https://guarded-inlet-86447.herokuapp.com/user/admin/${email}`,{
            method:"PUT",
            headers:{
                authorization:`Bearer ${localStorage.getItem('accesstoken')}`
            }

        }).then(rs=>{
            if(rs.status===403)
            {
                toast.error("Failed to Make an admin")
            }
           return rs.json()
        })
        .then(data=>{
           if(data.modifiedCount>0){
            refetch()
            toast.success(`Successfully made an admin`)

           }
        })

    }
    return (
        <tr>
            <th>{index+1}</th>
            <td>{email}</td>
            <td>{role!=='admin'&&<button onClick={makeAdmin} className="btn btn-xs">Make Admin</button>}</td>
            <td><button className="btn btn-xs">Remove User</button></td>
            <ToastContainer></ToastContainer>
        </tr>
    );
};

export default UserRow;